import React from 'react';
import UserUtils from "../../../../services/User/UserUtils";
import AdvertUserComponent from "../../../../components/User/components/AdvertUser";
import {connect, DispatchProp} from "react-redux";
import {RootState} from "../../../../../reducers";
import {getStoreConfigLoyalty} from "../../../../services/Store/reducer";
import {getUser} from "../../../../services/User/reducer";
import {withTranslation} from "react-i18next";

interface OwnProps {
    menuAdverts: any[];
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;

const MenuAdvertBanner = ({menuAdverts, config_loyalty, user}: Props) => {
    if (menuAdverts.length === 0) {
        if (UserUtils.isLoyaltyRegistration(config_loyalty)) {
            if (!user || !user.name) {
                return (
                    <AdvertUserComponent/>
                )
            }
        }
    }

    return <></>;
}
const mapStateToProps = (state: RootState) => ({
    config_loyalty: getStoreConfigLoyalty(state.config),
    user: getUser(state.user)
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(MenuAdvertBanner));
